// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3-1pT","selected":"Chip_selected__jlH3w"};